import { z } from 'zod';

const numberList = z
  .object({
    value: z
      .union([z.number(), z.array(z.number())])
      .nullable()
      .optional(),
    operator: z.enum(['eq', 'in', 'null', 'notnull']),
  })
  .optional();

const stringFilter = z
  .object({
    value: z.string().optional(),
    operator: z.enum(['eq', 'containsIgnoreCase']),
  })
  .optional();

const stringList = z
  .object({
    value: z
      .union([z.string(), z.array(z.string())])
      .nullable()
      .optional(),
    operator: z.enum(['eq', 'in']),
  })
  .optional();

export const descendantItemFilterSearchSchema = z.object({
  'descendant.itemTypeId': numberList,
  'descendant.estimationId': numberList,
  'descendant.estimationSchemeId': numberList,
  'descendant.statusId': numberList,
  'descendant.teamId': numberList,
  'descendant.planId': numberList,
  'descendant.integrationId': numberList,
  'descendant.boxId': numberList,
  'descendant.name': stringFilter,
  'descendant.externalKey': stringFilter,
  hasDependencies: stringList,
});

export const isDescendantPicklistFilterKey = (
  key: string,
): key is keyof z.infer<typeof descendantItemFilterSearchSchema> => {
  return key in descendantItemFilterSearchSchema.shape;
};
